// extracted by mini-css-extract-plugin
export default {"plusTag":"TagSection_plusTag__wuVQb","tagInput":"TagSection_tagInput__PMAgD","container":"TagSection_container__ilr+P"};